import { useMemo } from 'react'
import { useListInspectionChecklists } from '~/modules/inspection_checklist/data/useData'
import { IAircraftModel, ICompany, IInspectionChecklist } from '~/utils/types'

interface UseChecklistOptionsProps {
  aircraftModelId?: string
  customerId?: string
  enabled?: boolean
}

export const useChecklistOptions = ({
  aircraftModelId,
  customerId,
  enabled = true,
}: UseChecklistOptionsProps = {}) => {
  const { data: allChecklists, isLoading } = useListInspectionChecklists({ lean: true, enabled })

  const { genericChecklists, specificChecklists } = useMemo(() => {
    if (!allChecklists || !enabled) {
      return { genericChecklists: [], specificChecklists: [] }
    }

    const checklists = allChecklists as IInspectionChecklist[]
    const genericChecklists = checklists.filter((item) => !item.aircraft_model)
    const specificChecklists = checklists.filter((item) => {
      if (!item.aircraft_model || !aircraftModelId || !customerId) {
        return false
      }

      const itemAircraftModelId =
        (item.aircraft_model as IAircraftModel)?._id ?? (item.aircraft_model as string)
      const itemCustomerId = (item.customer as ICompany)?._id ?? (item.customer as string)

      return itemAircraftModelId === aircraftModelId && itemCustomerId === customerId
    })

    return { genericChecklists, specificChecklists }
  }, [allChecklists, aircraftModelId, customerId, enabled])

  return {
    genericChecklists,
    specificChecklists,
    isLoading,
  }
}
